import { useEffect, useState, type ReactNode } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { TextLink, ArrowLeftSolidIcon } from '../../atoms';
import { useTranslation } from 'next-i18next';

export interface CollapsableProps
    extends CommonProps,
        VariantProps<typeof CollapsableStyles> {
    collapsableElementId: string;
    height?: number;
    children?: ReactNode;
}

export const CollapsableStyles = tv({
    slots: {
        root: '',
    },
    variants: {},
});

export const Collapsable = ({
    className,
    children,
    collapsableElementId,
    height = 450,
    testId = 'collapsable',
    ...props
}: CollapsableProps): JSX.Element => {
    const { root } = CollapsableStyles();
    const [showMore, setShowMore] = useState<boolean>(false);
    const [descriptionHeight, setDescriptionHeight] = useState<number>(50);
    const { t } = useTranslation(['event']);

    useEffect(() => {
        setDescriptionHeight(
            document.getElementById(collapsableElementId)?.offsetHeight ?? 50
        );

        setShowMore(false);
    }, [t]);

    const onLoadMore = () => {
        setShowMore(true);
    };
    return (
        <div className={root({ className })} {...props} data-testid={testId}>
            <div
                className={
                    !showMore && descriptionHeight > height
                        ? 'fade-newsCards'
                        : ''
                }
                {...(!showMore && descriptionHeight > height
                    ? { style: { maxHeight: `${height}px` } }
                    : undefined)}
            >
                {children}
            </div>

            {!showMore && descriptionHeight > height && (
                <div className="mb-4 mt-8 grid grid-cols-1">
                    <TextLink
                        className="mx-auto lg:mx-0"
                        icon={
                            <ArrowLeftSolidIcon
                                className="rotate-[270deg]"
                                size="sm"
                            />
                        }
                        iconAlign="right"
                        onClick={onLoadMore}
                    >
                        {t('ctaLabels.readMore', { ns: 'event' })}
                    </TextLink>
                </div>
            )}
        </div>
    );
};
